module.exports = __webpack_public_path__ + "img/germanzzzz.c44202e2.webp";